import React from 'react';
import { Calendar, MapPin, ArrowRight } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
import { Link } from 'react-router-dom';

const EventsSection = () => {
  const { translations, language } = useLanguage();
  const events = translations?.events || [];
  
  const registerText = language === 'fr' ? "S'inscrire" : 'Register';

  if (!events.length) return null;

  return (
    <section id="events" className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1D1D1D]">
            {translations?.eventsTitle}
          </h2>
          <p className="mt-4 text-lg text-gray-600">
            {translations?.eventsSubtitle}
          </p>
        </div>

        {/* Events Grid */}
        <div className="grid lg:grid-cols-3 gap-8">
          {events.map((event, index) => (
            <div
              key={event.id}
              className={`relative overflow-hidden group ${
                index === 0 ? 'lg:col-span-2 lg:row-span-2' : ''
              }`}
            >
              <div className={`relative ${
                index === 0 ? 'h-[500px]' : 'h-[250px]'
              } overflow-hidden`}>
                <img
                  src={event.image}
                  alt={event.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent" />
                
                {/* Content Overlay */}
                <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                  <div className="flex items-center gap-4 mb-3 text-sm">
                    <span className="flex items-center gap-1">
                      <Calendar className="w-4 h-4" />
                      {event.date}
                    </span>
                    <span className="flex items-center gap-1">
                      <MapPin className="w-4 h-4" />
                      {event.location}
                    </span>
                  </div>
                  <h3 className={`font-bold mb-2 ${
                    index === 0 ? 'text-2xl md:text-3xl' : 'text-xl'
                  }`}>
                    {event.title}
                  </h3>
                  <p className={`text-white/80 mb-4 ${
                    index === 0 ? '' : 'text-sm line-clamp-2'
                  }`}>
                    {event.description}
                  </p>
                  <Link
                    to="/register"
                    className="inline-flex items-center gap-2 bg-[#CD0000] text-white px-4 py-2 font-bold hover:bg-[#c91560] transition-colors"
                  >
                    {registerText} <ArrowRight className="w-4 h-4" />
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default EventsSection;
